import functions from "../../Data/Functions"

// Define Variable names for all the arrays
let ShirtSizes
let Compids = [3211, 3212, 3213, 3214, 3215, 3216, 3217, 3218, 3219, 3220, 3221, 3222, 3876, 3877, 3878, 3879]

export default {

    LookupTeams: async (Assoc, Gender) => {
        let AllTeams = await functions.GetCodeBy({
            Association: Assoc,
            Gender: functions.getCompGender(Gender)
        }, true)

        let Teams = AllTeams.filter((element) => {
            return Compids.includes(element.State_Champs)
        })

        return Teams
    },

    // Shirt Details
    LookupShirtSizes: async () => {
        ShirtSizes = await functions.GetCodeBy({ Type: "Stats Shirt Sizes" }, true)
        ShirtSizes.sort((a, b) => { return a.Code_id - b.Code_id });
        return ShirtSizes
    },

    CompType: ["Male Competition", "Female Competition"],
    PlayerRoles: ["GUARD", "FORWARD", "CENTER"],
    StaffRoles: ["Coach", "Assistant Coach", "Team Manager"],
    StaffRoleids: [3, 9, 10],
    StaffAccredids: [7092, 7094, 7093],
    PlayerAccred: 7091

}